import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { ConnectionItemShape } from '../../helpers/propTypeShapes';
import { maxLength, required, validate } from '../../helpers/validation';

export default function DefaultForm({ handleOnConnectionFormChange, connection, setIsFormValid }) {
  const [inputErrors, setInputErrors] = useState({});
  const [visitedInputs, setVisitedInputs] = useState({});

  useEffect(() => {
    const errors = validate(connection, {
      title: [required(), maxLength(126)],
    });

    setInputErrors(errors);
    setIsFormValid(Object.keys(errors).length === 0);
  }, [connection, setIsFormValid]);

  const handleOnBlur = (event) => {
    const propertyName = event.target.name;
    setVisitedInputs((inputs) => ({ ...inputs, [propertyName]: true }));
  };

  return (
    <div>
      <div className="form-group">
        <label htmlFor="connection-title">
          Integration title
          <input
            className={classnames({ 'has-error': Boolean(inputErrors.title) && visitedInputs.title })}
            id="connection-title"
            name="title"
            value={connection.title}
            onBlur={handleOnBlur}
            onChange={(event) => handleOnConnectionFormChange({ ...connection, title: event.target.value })}
          />
        </label>
      </div>

      {/* Remove Access Level Selector Until Platform add support for it */}
      {/* <div className="form-group">
        <label htmlFor="connection-access">
          access
          <div className="select-content">
            <select
              id="connection-access"
              name="connection-access"
              onChange={(event) => handleOnConnectionFormChange({ ...connection, accessLevel: event.target.value })}
              value={connection.accessLevel}
            >
              <option value="Admin">Admin</option>
              <option value="Broadcasters">Broadcasters</option>
              <option value="Just Me">Just Me</option>
            </select>
          </div>
        </label>
      </div> */}
    </div>
  );
}

DefaultForm.propTypes = {
  connection: ConnectionItemShape.isRequired,
  handleOnConnectionFormChange: PropTypes.func.isRequired,
  setIsFormValid: PropTypes.func.isRequired,
};
